import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';

import DropZone from 'components/Shared/DropZone';
import PieceGestionSearch from 'components/Shared/PieceGestionSearch';
import LigneGestionQualification from 'components/Shared/LigneGestionQualification';
import ColisLogistiqueQualification from 'components/Shared/ColisLogistiqueQualification';

import Type from 'components/Shared/Type';
import Categorie from 'components/Shared/Categorie';
import Qualification from 'components/Shared/Qualification';

import { ReclamationQualificationDetailCodes } from 'constants.js';
import { AnomalieType } from 'constants.js';

const styles = theme => ({
    flexContainer: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    row: {
        flexBasis: '100%',
        marginBottom: '10px'
    },
    formControl: {
        margin: 0
    },
    group: {
        margin: theme.spacing(1, 0)
    },
    heightLabel: {
        height: '30px'
    }
});

class SouffranceStep extends React.Component {
    state = {
        expandedPanel: 'panelPiece'
    };

    componentDidMount() {
        // On détermine si on doit rendre accessible le bouton pour passer à l'étape suivante ou le bouton de création.
        const { reclamation, onNextStepValid } = this.props;

        // On vérifie que la réclamation possède un enregistrement pour chaque détail.
        let nextStepValid = false;
        if (reclamation !== null) {

            if (reclamation.numeroPiece.length > 0 &&
                reclamation.lignes.length > 0) {
                nextStepValid = true;
            }
        }

        onNextStepValid(nextStepValid);
    }

    checkErrors() {
        const { reclamation } = this.props;

        let errors = [];

        if (reclamation.ligneOuColis === 'ligne' && reclamation.lignes.length === 0) {
            errors.push({ key: ReclamationQualificationDetailCodes.NbLignes, errorMsg: 'Saisie obligatoire sur au moins une ligne.' });
        } else {
            errors.push({ key: ReclamationQualificationDetailCodes.NbLignes, errorMsg: null });
        }

        if (reclamation.ligneOuColis === 'colis' && reclamation.colis.length === 0) {
            errors.push({ key: ReclamationQualificationDetailCodes.NbColis, errorMsg: 'Sélectionnez au moins un colis.' });
        } else {
            errors.push({ key: ReclamationQualificationDetailCodes.NbColis, errorMsg: null });
        }

        return errors;
    }

    handleChangePanel = panel => (event, expandedPanel) => {
        this.setState({
            ...this.state,
            expandedPanel: expandedPanel ? panel : false
        });
    };

    handleChange = (event) => {
        const { onChange } = this.props;

        const errors = this.checkErrors();

        onChange(event, errors);
    }

    handleSelectPiece = (value) => {
        const { onSelectPiece } = this.props;

        // On ouvre le panel
        this.setState({
            ...this.state,
            expandedPanel: 'panelLignes'
        });

        const errors = this.checkErrors();

        onSelectPiece(value, errors);
    }


    handleAddLigne = (ligne) => {
        const { onAddLigne } = this.props;

        const errors = this.checkErrors();

        onAddLigne(ligne, errors);
    }

    handleRemoveLigne = (numeroLigne) => {
        const { onRemoveLigne } = this.props;

        const errors = this.checkErrors();

        onRemoveLigne(numeroLigne, errors);
    }

    handleLigneOuColisChange = (event) => {
        const { onLigneOuColisChange } = this.props;

        onLigneOuColisChange(event.target.value);
    }

    handleAddColis = (colisId, typeAnomalie) => {
        const { onAddColis } = this.props;

        const errors = this.checkErrors();

        onAddColis(colisId, typeAnomalie, errors);
    }

    handleRemoveColis = colisId => {
        const { onRemoveColis } = this.props;

        const errors = this.checkErrors();

        onRemoveColis(colisId, errors);
    }


    render() {
        const { classes, reclamation, namespace } = this.props;
        const { expandedPanel } = this.state;

        return (
            <React.Fragment>

                <div className={classes.row}>
                    <TextField
                        multiline
                        fullWidth
                        name="commentaire"
                        label="Commentaire"
                        placeholder="Décrire le problème rencontré"
                        maxRows="3"
                        onChange={this.handleChange}
                        value={reclamation.commentaire}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </div>

                <div className={classes.row}>
                    <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} />
                </div>

                <div className={classes.row}>
                    <Accordion expanded={expandedPanel === 'panelPiece'} onChange={this.handleChangePanel('panelPiece')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            className={classes.panelSummary}
                        >
                            <Typography >Rechercher une pièce* (obligatoire pour accéder aux lignes et colis)</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <PieceGestionSearch
                                onSelectPiece={this.handleSelectPiece}
                                client={reclamation.client}
                                withLignes
                                namespace={namespace}
                                warningReclamation
                                defautProduitInfos={false}
                                logistiqueInfos={false}
                                defautNumeroPiece={reclamation.numeroPiece}
                            />
                        </AccordionDetails>
                    </Accordion>


                    {reclamation.numeroPiece && (

                        <Accordion expanded={expandedPanel === 'panelLignes'} onChange={this.handleChangePanel('panelLignes')}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.panelSummary}>
                                <Typography>Choissisez un type de séléction :</Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.flexContainer}>
                                <div className={classes.row}>
                                    <FormControl component="fieldset" className={classes.formControl} required>
                                        <RadioGroup
                                            name="ligne-ou-colis"
                                            className={classes.group}
                                            value={reclamation.ligneOuColis}
                                            onChange={this.handleLigneOuColisChange}
                                        >
                                            <FormControlLabel className={classes.heightLabel} value="ligne" control={<Radio />} label="Lignes(s)" />
                                            {!this.props.lignesUniquement && (
                                                <FormControlLabel className={classes.heightLabel} value="colis" control={<Radio />} label="Colis" />
                                            )}
                                            <FormControlLabel className={classes.heightLabel} value="tout" control={<Radio />} label="Commande complète" />
                                        </RadioGroup>
                                    </FormControl>
                                </div>


                                <div className={classes.row}>
                                    {reclamation.ligneOuColis === 'ligne' &&
                                        <div className={classes.row}>
                                            <Typography>Sélectionner : une ou plusieurs lignes *</Typography>
                                            <LigneGestionQualification
                                                reclamation={reclamation}
                                                onAddLigne={this.handleAddLigne}
                                                onRemoveLigne={this.handleRemoveLigne}
                                                typeAnomalie={AnomalieType.QuantiteArticleIncorrecte}
                                            />
                                        </div>
                                    }

                                    {reclamation.ligneOuColis === 'colis' &&
                                        <div className={classes.row}>
                                            <Typography>Sélectionner : le ou les colis manquants *</Typography>
                                            <ColisLogistiqueQualification
                                                reclamation={reclamation}
                                                onAddColis={this.handleAddColis}
                                                onRemoveColis={this.handleRemoveColis}
                                                typeAnomalie={AnomalieType.QuantiteArticleIncorrecte}
                                            />
                                        </div>
                                    }

                                </div>
                            </AccordionDetails>
                        </Accordion>

                    )}

                </div>


            </React.Fragment>
        );
    }
}

SouffranceStep.propTypes = {
    reclamation: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onDetailChange: PropTypes.func.isRequired,
    onSelectPiece: PropTypes.func.isRequired,
    onLigneOuColisChange: PropTypes.func.isRequired,
    onAddLigne: PropTypes.func.isRequired,
    onRemoveLigne: PropTypes.func.isRequired,
    onAddColis: PropTypes.func.isRequired,
    onRemoveColis: PropTypes.func.isRequired,
    validationErrors: PropTypes.array,
    onNextStepValid: PropTypes.func.isRequired,
    namespace: PropTypes.string.isRequired
};

export default withStyles(styles)(SouffranceStep);